import { ActionType, ComponentType } from '../../enums';
import { calculateId } from '../hotelsUtils';
import { PromotionEventPayloadOptions, PromotionEventPayloadReturn } from '../hotelsUtils/types';

export const createViewPromotionEventPayload = ({ promotion }: PromotionEventPayloadOptions): PromotionEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.VIEW,
      component_type: ComponentType.PROMOTION_LIST,
      items: [
        {
          promotion_id: calculateId(promotion.name),
          promotion_name: promotion.name,
          creative_name: promotion.assetName,
          creative_slot: promotion.slot,
        },
      ],
    },
  };
};
